<div class="bg-white rounded-10 p-5">
  <div class="text-center font-roboto-700 text-17 mb-5 max-sm:mb-2">
    {{ "H2H" | translate }}
  </div>

  <div class="mb-5">
    <app-tab-bar
      [optionsFilterMatch]="{
        homeTeam: infoMatch.homeTeam.name,
        awayTeam: infoMatch.awayTeam.name
      }"
      filtersOptions="h2h"
      (selectedIndexChange)="menuSelected($event)"
    ></app-tab-bar>
  </div>

  <div *ngIf="optionFilterSelected === 0" class="flex flex-col gap-5">
    <nz-skeleton [nzActive]="true" [nzLoading]="loadingHome">
      <app-dashboard-info
        [infoH2H]="{
          info: h2hStatics.homeInfo,
          name: infoMatch.homeTeam.name
        }"
      ></app-dashboard-info>
    </nz-skeleton>

    <nz-skeleton [nzActive]="true" [nzLoading]="loadingAway">
      <app-dashboard-info
        [infoH2H]="{
          info: h2hStatics.awayInfo,
          name: infoMatch.awayTeam.name
        }"
      ></app-dashboard-info>
    </nz-skeleton>

    <nz-skeleton [nzActive]="true" [nzLoading]="loadingVs">
      <app-dashboard-info
        [infoH2H]="{
          info: h2hStatics.homeVSaway,
          name: 'ClashesWithEachOther' | translate
        }"
      ></app-dashboard-info>
    </nz-skeleton>
  </div>

  <ng-container *ngIf="optionFilterSelected === 1">
    <nz-skeleton [nzActive]="true" [nzLoading]="loadingHome">
      <app-dashboard-info
        [infoH2H]="{
          info: h2hStatics.homeInfoFilter,
          name: infoMatch.homeTeam.name
        }"
      ></app-dashboard-info>
    </nz-skeleton>

    <nz-skeleton [nzActive]="true" [nzLoading]="loadingVs">
      <app-dashboard-info
        [infoH2H]="{
          info: h2hStatics.homeVSawayFilter,
          name: 'ClashesWithEachOther' | translate
        }"
      ></app-dashboard-info>
    </nz-skeleton>
  </ng-container>

  <ng-container *ngIf="optionFilterSelected === 2">
    <nz-skeleton [nzActive]="true" [nzLoading]="loadingAway">
      <app-dashboard-info
        [infoH2H]="{
          info: h2hStatics.awayInfoFilter,
          name: infoMatch.awayTeam.name
        }"
      ></app-dashboard-info>
    </nz-skeleton>

    <nz-skeleton [nzActive]="true" [nzLoading]="loadingVs">
      <app-dashboard-info
        [infoH2H]="{
          info: h2hStatics.awayVsHomeFilter,
          name: 'ClashesWithEachOther' | translate
        }"
      ></app-dashboard-info>
    </nz-skeleton>
  </ng-container>
</div>
